import { ref, reactive, computed } from 'vue'
import { defineStore } from 'pinia'

// import Ajax from '@utils/ajax'

export const useActivity = defineStore('activity', () => {

    const activities = ref([])

    const getActivities = computed(() => {
        return activities.value
    })

    const isActivitiesLoading = ref(false)

    // fetch activities
    const fetchActivities = async (activity_id = null) => {
        // isActivitiesLoading.value = true
        // const response = await Ajax.get('admin_get_activities', { activity_id })
        // isActivitiesLoading.value = false

        // Log('activities', response.data)

        // return response.success ? response.data : []
    }

    // update activity
    const updateActivity = async (data) => {
        console.log('update activity', data)
        // const response = await Ajax.post('admin_update_activity', data)
    }

    // export
    return {
        activities,
        getActivities,
        isActivitiesLoading,

        fetchActivities,
        updateActivity
    }
})
